'use client'

// src/useDevice.ts
import { useMemo, useSyncExternalStore } from "react";
import { readCookie } from "@wbk/utils";
var subscribe = () => () => {
};
var getServerUserAgent = () => "SSR";
var getUserAgent = () => typeof navigator === "undefined" ? getServerUserAgent() : navigator.userAgent;
var useDeviceDetect = () => {
  const userAgent = useSyncExternalStore(subscribe, getUserAgent, getServerUserAgent);
  const isSSR = useMemo(() => {
    return !!userAgent.match(/SSR/i);
  }, [userAgent]);
  const isAndroid = useMemo(() => {
    return !!userAgent.match(/Android/i);
  }, [userAgent]);
  const isIOS = useMemo(() => {
    return !!userAgent.match(/iPhone|iPad|iPod|Mobile/i);
  }, [userAgent]);
  const isMac = useMemo(() => {
    return !!userAgent.match(/Mac/i);
  }, [userAgent]);
  const isOpera = useMemo(() => {
    return !!userAgent.match(/Opera Mini/i);
  }, [userAgent]);
  const isWindowsMobile = useMemo(() => {
    return !!userAgent.match(/IEMobile/i);
  }, [userAgent]);
  const isSafari = useMemo(() => {
    return !!userAgent.match(/Safari/i) && userAgent.indexOf("Chrome") <= -1;
  }, [userAgent]);
  const isWebView = useMemo(() => {
    const savedWebview = readCookie("webview_mode");
    return !!savedWebview || !!userAgent.match(/WBKWebView/i);
  }, [userAgent]);
  const isMobile = useMemo(() => {
    return isAndroid || isIOS || isOpera || isWindowsMobile || isWebView;
  }, [isAndroid, isIOS, isOpera, isWindowsMobile, isWebView]);
  const isDesktop = useMemo(() => {
    return !isMobile;
  }, [isMobile]);
  return {
    userAgent,
    isSSR,
    isAndroid,
    isIOS,
    isMac,
    isOpera,
    isWindowsMobile,
    isSafari,
    isMobile,
    isDesktop,
    isWebView
  };
};

export {
  useDeviceDetect
};
//# sourceMappingURL=chunk-H32VDNP4.mjs.map